<div class="d-flex mx-0 flex-column flex-md-row justify-contet-between p-white border-bottom secondaryMenu px-4 py-3">
    <div class="d-flex flex-column col">
        <h3 class="mt-0 mb-1">All Job Chains</h3>
        <p-breadcrumb [model]="items"></p-breadcrumb>
    </div>
    <div class="d-flex justify-content-start justify-content-md-end col mt-2 mt-md-0">
        <button pButton type="button" icon="pi pi-plus" label="Add Job Chain" iconPos="left" routerLink="/createJobChain"></button>
    </div>
</div>

<div class="p-white shadow m-3">
<p-table [value]="products" [autoLayout]="true" responsiveLayout="scroll" styleClass="p-datatable-striped">
    <ng-template pTemplate="caption">
        <div class="d-flex flex-row justify-content-between">
            <span class="p-input-icon-left p-ml-auto">
                <i class="pi pi-search"></i>
                <input pInputText type="text"  placeholder="Search keyword" />
            </span>
            <button pButton label="Clear" class="p-button-outlined" icon="pi pi-filter-slash"></button>
        </div>
    </ng-template>
    <ng-template pTemplate="header">
        <tr>
            <th  pSortableColumn="code">Chain Name <p-sortIcon field="code"></p-sortIcon></th>
            <!-- <th  pSortableColumn="model">Vehicle model<p-sortIcon field="code"></p-sortIcon></th>
            <th  pSortableColumn="driver">Driver Name<p-sortIcon field="code"></p-sortIcon></th> -->
            <th>Chain Code <p-columnFilter type="text" field="CreatedOn" display="menu"></p-columnFilter> </th>
            <th>Description <p-columnFilter type="text" field="CreatedOn" display="menu"></p-columnFilter></th>
            <th>Company <p-columnFilter type="text" field="CreatedOn" display="menu"></p-columnFilter></th>
            <th>Operation Group <p-columnFilter type="text" field="CreatedOn" display="menu"></p-columnFilter></th>
            <th>Created On <p-columnFilter type="date" field="CreatedOn" display="menu"></p-columnFilter></th>
            <th>Created By<p-columnFilter type="text" field="CreatedBy" display="menu"></p-columnFilter> </th>
            <th></th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-product>
        <tr>
            <td><a (click)="visibleSidebar2 = true">Fuel Charges Fleet Chain </a></td>
            <td>JC62 506 973</td>
            <td>Fuel Charges Fleet Chain</td>
            <td>Hayleys Agro</td>
            <td>Admin User</td>
            <td>Felix Lowe</td>
            <td>2020 July 12</td>
            <td>
                <!-- <button pButton pRipple type="button" icon="pi pi-check" class="p-button-text"></button> -->
                <button pButton pRipple type="button" icon="pi pi-pencil" class="p-button-success p-button-text"></button>
                <button pButton pRipple type="button" icon="pi pi-trash" class="p-button-danger p-button-text"></button>
            </td>
        </tr>
    </ng-template>
</p-table>
<div class="d-flex justify-content-end">
           
    <p-paginator [rows]="10" [showCurrentPageReport]="true" currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries" [rowsPerPageOptions]="[10,20,30]"></p-paginator>
</div>
</div>


<p-sidebar [(visible)]="visibleSidebar2" position="right" [baseZIndex]="10000" [style]="{width:'30rem'}">
    <div class="d-flex flex-row align-items-center justify-content-between mb-5">
        <h4 class="my-0">Fuel Charges Fleet Chain</h4>
        <p-tag class="ms-2" value="Parent Company"></p-tag>
    </div>
    <div class="d-flex flex-column mb-4">
        <p-timeline [value]="events1" align="left" styleClass="customized-timeline">
            <ng-template pTemplate="marker" let-event>
                <span class="custom-marker p-shadow-2">
                    <div [ngClass]="event.iconclass" ></div>
                </span>
            </ng-template>
            <ng-template pTemplate="content" let-event>
                <div [ngClass]="event.class" class="p-3">
                    <p class="step-text mt-0 mb-0">Request Created.</p>
                    <p class="step-text mt-0 mb-0">2021 Auguts 21, 10:21 AM</p>
                </div>
            </ng-template>
        </p-timeline>
    </div>
</p-sidebar>